import NumberOfResults from './NumberOfResults';

export default NumberOfResults;
